import React from 'react';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';
import { Loader2, Navigation } from 'lucide-react';
import { Button } from '../ui/button';

const libraries = ['places', 'geometry'];

const mapContainerStyle = {
    width: '100%',
    height: '100%',
    borderRadius: '0.5rem',
};

const defaultOptions = {
    disableDefaultUI: false,
    zoomControl: true,
    streetViewControl: true,
    mapTypeControl: false,
    fullscreenControl: true,
};

export default function PropertyMap({ lat, lng, title, address, className = "h-64" }) {
    const { isLoaded, loadError } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
    });

    const parsedLat = parseFloat(lat);
    const parsedLng = parseFloat(lng);
    const isValidCoords = !isNaN(parsedLat) && !isNaN(parsedLng);

    const center = isValidCoords
        ? { lat: parsedLat, lng: parsedLng }
        : { lat: 17.385, lng: 78.4867 }; // Default to Hyderabad

    if (loadError) return <div className="p-4 bg-red-50 text-red-600 rounded">Error loading map</div>;
    if (!isLoaded) return <div className={`flex items-center justify-center bg-navy-50 rounded ${className}`}><Loader2 className="w-8 h-8 animate-spin text-navy-400" /></div>;

    return (
        <div className={`relative rounded-lg overflow-hidden border border-navy-200 ${className}`}>
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={15}
                center={center}
                options={defaultOptions}
            >
                {isValidCoords && (
                    <MarkerF
                        position={center}
                        title={title}
                    />
                )}
            </GoogleMap>

            <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm p-3 rounded-lg shadow-lg border border-navy-100 flex items-center justify-between gap-3">
                <div className="truncate">
                    <p className="text-sm font-medium text-navy-900 truncate">{title}</p>
                    <p className="text-xs text-navy-500 truncate">{address}</p>
                </div>
                <Button
                    size="sm"
                    className="shrink-0 bg-blue-600 hover:bg-blue-700 text-white"
                    onClick={() => window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`, '_blank')}
                >
                    <Navigation className="w-3.5 h-3.5 mr-1.5" />
                    Directions
                </Button>
            </div>
        </div>
    );
}

